import React from "react";
import Resources from "../../../Resources/Resources";
import {Col, Container, Row} from "react-bootstrap";
import {APP_SECTION} from "../../../scripts/constants";
import {mygaSession} from "../../../scripts/myga-session";
import {saveApplication, startApplication} from "../../../scripts/sync-manager";
import AppContentWrapper from "../AppContentWrapper/AppContentWrapper";
import MYGAStrings from "../../../Resources/Content/MYGAStrings";
import {NassauLog} from "../../../scripts/myga-utils";
import {PageManager} from "../../../scripts/page-manager";
import Question from "../../../components/Questions/Question";
import {isFL} from "../../../scripts/validation";

class Knockout extends React.Component {

  constructor(props) {
    super(props);

    // Load the component state from the current application
    this.state = {
      idVerify: {...mygaSession.getCurrentAppIdVerify()},
      goals: {...mygaSession.getCurrentAppGoals()},
      funds: {...mygaSession.getCurrentAppFunds()},
      general: {...mygaSession.getCurrentAppGeneral()},
      errorMessage:''
    };
    NassauLog(`Knockout - state: ${JSON.stringify(this.state,null,2)}`);
  }

  componentDidMount() {
    
    // Get the current application
    let app = mygaSession.getCurrentApp();
    if (app===null) {
      
      // request a new application from the backend
      startApplication()
          .then((data)=>{
            // NassauLog("app: " + JSON.stringify(data));
            this.setState({
              idVerify: {...mygaSession.getCurrentAppIdVerify()},
              goals: {...mygaSession.getCurrentAppGoals()},
              funds: {...mygaSession.getCurrentAppFunds()},
              general: {...mygaSession.getCurrentAppGeneral()},
            })
          })
          .catch((err) => {
            NassauLog(err);
            // TODO: Handle the error. Message popup?
          });
      
    } else {
      // OK continue on.
    }
  }

  onBackPressed = async () => {
    await this.saveApplication()
  }

  onNextPressed = async () => {
    await this.saveApplication()
  }
  
  saveApplication = async () => {
    // Update the current application
    mygaSession.setCurrentAppSectionData(APP_SECTION.goals, this.state.goals);
    mygaSession.setCurrentAppSectionData(APP_SECTION.identity1, this.state.idVerify);
    mygaSession.setCurrentAppSectionData(APP_SECTION.funds,this.state.funds);
    mygaSession.setCurrentAppSectionData(APP_SECTION.general,this.state.general);
    await saveApplication(APP_SECTION.goals);
    await saveApplication(APP_SECTION.identity1);
    await saveApplication(APP_SECTION.funds);
    await saveApplication(APP_SECTION.general);
  };
  
  handleChange = (section) => (field) => (e) => {
    let data = this.state[section];
    data[field] = e.target && e.target.value !== undefined ? e.target.value : e;
    // NassauLog(`Knockout: field:${field} value:${data[field]}`);
    let nextState = {errorMessage:''};
    nextState[section] = data;
    this.setState(nextState);
  };
  
  validate = () => {
    // 2021.07.16.ADivelbiss - onNext Validation
    if (!this.pageForm.checkValidity()) {
      this.pageForm.classList.add('was-validated');
      this.setState({
        errorMessage: MYGAStrings.Goals_ErrorMissingInformation
      });
      return false;
    }
  
    return true;
  };

  render() {
    return (
        <AppContentWrapper
            onBackPressed={this.onBackPressed}
            onNextPressed={this.onNextPressed}
            validateOnNext={this.validate}
            updatePage={this.props.updatePage}
            errorMessage={this.state.errorMessage}>

          <form className={'needs-validation'}
                         ref={(form) => {
                           this.pageForm = form;
                         }}>
  
            <Container>
              <Row className="page-section pt-0 mt-0">
                <Col className=" text-center pb-3">
                  <div>Before we get started please answer the following questions...
                  </div>
                </Col>
              </Row>
            </Container>
  
            {
              isFL() ? (
                  // FL Knockout questions.
                  <Container>
                    <Question
                        containerClass={'pb-4 pl-4 pl-md-5'}
                        data={this.state.idVerify}
                        question={PageManager.getQuestionByName('isUSCitizen')}
                        onChange={this.handleChange('idVerify')}/>
      
                    <Question
                        containerClass={'pb-4 pl-4 pl-md-5'}
                        data={this.state.general}
                        question={PageManager.getQuestionByName('assistedLivingFL')}
                        onChange={this.handleChange('general')}/>
      
                    <Question
                        containerClass={'pb-4 pl-4 pl-md-5'}
                        data={this.state.general}
                        question={PageManager.getQuestionByName('terminalIllnessFL')}
                        onChange={this.handleChange('general')}/>
      
                    <Question
                        containerClass={'pb-4 pl-4 pl-md-5'}
                        data={this.state.general}
                        question={PageManager.getQuestionByName('memoryDiseaseFL')}
                        onChange={this.handleChange('general')}/>
      
                    <Question
                        containerClass={'pb-4 pl-4 pl-md-5'}
                        data={this.state.goals}
                        question={PageManager.getQuestionByName('isUsingReverseMortgageFL')}
                        onChange={this.handleChange('goals')}/>
  
                    <Question
                        containerClass={'pb-4 pl-4 pl-md-5'}
                        question={PageManager.getQuestionByName('expectLumpSumPaymentsFL')}
                        data={this.state.funds}
                        onChange={this.handleChange('funds')}
                    />
    
                  </Container>
              ) : (
                  // NON-FL / Default questions
                  <Container>
                    <Question
                        containerClass={'pb-4 pl-4 pl-md-5'}
                        data={this.state.idVerify}
                        question={PageManager.getQuestionByName('isUSCitizen')}
                        onChange={this.handleChange('idVerify')}/>
      
                    <Question
                        containerClass={'pb-4 pl-4 pl-md-5'}
                        data={this.state.goals}
                        question={PageManager.getQuestionByName('isApplicantImpaired')}
                        onChange={this.handleChange('goals')}/>
      
                    <Question
                        containerClass={'pb-4 pl-4 pl-md-5'}
                        data={this.state.goals}
                        question={PageManager.getQuestionByName('isUsingReverseMortgage')}
                        onChange={this.handleChange('goals')}/>
      
                  </Container>
              )
            }
            
          </form>
          
        </AppContentWrapper>
    );
    
  }
}

export default Knockout;